import { get, post, put, del } from 'utils/methods';

export function getJobResultApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}job-palettes`, data, headers);
}

export function addJobPaletteApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/job-palette`, data, headers);
}

export function toggleJobResultStepsApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/job-palette/state`, data, headers);
}

export function deleteJobResultApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_PP}commands/job-palette`, data, headers);
}

export function addNewPaletteApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/palette`, data, headers);
}

export function updateJobResultsApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_PP}commands/job-palette`, data, headers);
}

export function forcePrintPaletteApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/print-palette`, data, headers);
}

export function generateTemporaryPaperApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}job-palette/temporary`, data, headers);
}

export function getAllJobResultsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}all-job-palettes`, data, headers);
}
